import { render } from "./StockItemList.vue?vue&type=template&id=47c79f31&ts=true"
import script from "./StockItemList.vue?vue&type=script&lang=ts"
export * from "./StockItemList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__